import { render, staticRenderFns } from "./Width.vue?vue&type=template&id=4dbe419d&"
import script from "./Width.vue?vue&type=script&lang=js&"
export * from "./Width.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports